import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasAdminPermission } from "@/utils/adminAccess";

/**
 * Guards an admin route by RBAC permission ("resource:action"). If the user
 * lacks it, redirect to the admin dashboard (which every panel user can see)
 * so a hidden tab can't be reached by typing its URL. The backend enforces the
 * same permission, so this is defense-in-depth, not the only gate.
 */
export const AdminRoute: React.FC<{ permission?: string; children: React.ReactNode }> = ({
  permission,
  children,
}) => {
  const { user } = useAuth();
  if (!hasAdminPermission(user as any, permission)) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
};

export default AdminRoute;
